import { useAppConfig } from '@ApplicationWide/AppConfig';

const EXTRA_BASE_DETAILS_FLAG_KEYS = new Set(['dateFieldLabelConsistencyFeatureFlag']);

const getBaseDetailsFeatureFlags = (companyBaseDetails = {}) => {
  // only including limited set of values from the company baseDetais for now
  const COMPANY_BASE_DETAILS_FEATURES_REGEX = /feature|enable|disable/iu;
  return Object.entries(companyBaseDetails).reduce((acc, [key, value]) => {
    if (COMPANY_BASE_DETAILS_FEATURES_REGEX.test(key) || EXTRA_BASE_DETAILS_FLAG_KEYS.has(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const useFeatureFlags = () => {
  const { application, company } = useAppConfig();
  if (!application && !company?.baseDetails) {
    return {};
  }

  const baseDetails = getBaseDetailsFeatureFlags(company?.baseDetails);
  return {
    ...(application?.featureFlags || {}),
    ...baseDetails,
  };
};

export const useIsFeatureFlagEnabled = (featureFlag) => {
  const featureFlags = useFeatureFlags();
  if (!Array.isArray(featureFlag)) {
    return Boolean(featureFlags?.[featureFlag]);
  }
  // if `featureFlag` provided is an Array, assume OR behaviour;
  // (this is for absence management, and are the only page
  // currently using an array for feature flag checks)
  return featureFlag.some((flag) => featureFlags?.[flag]);
};

export const getFeatureFlagFilter =
  (featureFlags) =>
  ({ featureFlag }) => {
    if (!featureFlag) {
      return true;
    }
    if (!Array.isArray(featureFlag)) {
      return featureFlags?.[featureFlag];
    }
    // if `featureFlag` on the route is an Array, assume OR behaviour;
    // (this is for absence management, and are the only routes
    // currently using an array of feature flags)
    return featureFlag.some((flag) => featureFlags?.[flag]);
  };

// feature flags that are based on company baseDetails, set in launch darkly;
// these should not be removed, as they are set per tenant
export const FEATURE_FLAG_WORKING_PATTERNS = 'workingPatternsFeatureFlag';
export const FEATURE_FLAG_WORKING_PATTERNS_ADMIN = 'workingPatternsAdminFeatureFlag';
export const FEATURE_FLAG_ABSENCE_MANAGEMENT = 'absenceManagementFeatureFlag';
export const FEATURE_FLAG_ABSENCE_MANAGEMENT_ADMIN = 'absenceManagementAdminFeatureFlag';
export const FEATURE_FLAG_DOCUMENT_V2 = 'documentV2FeatureFlag';
export const FEATURE_FLAG_PENDING_CHANGES_REPORT = 'pendingChangesReportFeatureFlag';
export const FEATURE_FLAG_DATE_FIELD_LABEL_CONSISTENCY = 'dateFieldLabelConsistencyFeatureFlag';
export const FEATURE_FLAG_FUTURE_DATED_TOKENS = 'futureDatedTokensFeatureFlag';
export const FEATURE_FLAG_FUTURE_DATED_DOCUMENTS = 'futureDatedDocumentsFeatureFlag';
